<template>
  <svg :width="width" :height="height">
    <g v-for="(leave, i) in root.leaves()"
       :transform="translate(leave)"
       :key="i" >
      <popover
         :key="i"
         :content="leave.data.name+' '+yFormatter(leave.value)"
         :delay="100"
         :hideDelay="100" >
        <rect
           @click="handleSelect(leave)"
           :class="selectableClass(leave)"
           :id="'leave_'+i"
           :width="leave.x1 - leave.x0"
           :height="leave.y1 - leave.y0"
           :fill="color(i)" />
        <clipPath :id="'clip-leave_'+i">
          <use :xlink:href="'#leave_'+i" />
        </clipPath>
        <text :clip-path="'url(#clip-leave_'+i+')'" >
          <tspan
             v-for="(word, i) in leave.data.name.split(' ')"
             x="4" :y="fontsize * (i+1)"
             :style="{'font-size': fontsize}" >
            {{ word }}
          </tspan>
        </text>
      </popover>
    </g>
  </svg>
</template>

<script>
import * as d3 from 'd3'
import * as d3Chromatic from 'd3-scale-chromatic'
import Graph from './Graph.vue'
import margin from '../mixins/margin.js'
import selectable from '../mixins/selectable.js'
import Popover from './Popover'

export default {
  extends: Graph,
  mixins: [
    margin,
    selectable
  ],
  components: {
    Popover
  },
  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    fontsize: {
      type: Number,
      default: 14
    },
    colorScale: {
      default: () => d3.scaleSequential(d3Chromatic.interpolateRainbow)
    }
  },
  computed: {
    root () {
      let me = d3
        .hierarchy(this.data)
        .sum(({count}) => count)
      let treemap = d3.treemap()
        .tile(d3.treemapResquarify)
        .size([this.width, this.height])
        .round(true)
        .paddingInner(1)
      treemap(me)
      return me
    },
    color () {
      const scale = this.colorScale || d3.scaleSequential(d3Chromatic.interpolateRainbow)
      return scale.domain([0, this.root.leaves().length])
    },

  },
  methods: {
    selectData (d) {
      return d.data
    },
    selectKey (d) {
      return d.id
    },
    translate (leave) {
      return `translate(${leave.x0}, ${leave.y0})`
    }
  }
}
</script>

<style scoped>
.selected {
    stroke: red
}
</style>



// WEBPACK FOOTER //
// node_modules/d3vue/components/TreeMap.vue